/* eslint-disable no-barrel-files/no-barrel-files */
// TODO: De-barrel-ize
import {
  GeckoAnalyticsProvider,
  useGeckoAnalytics,
} from './GeckoAnalyticsProvider'

export { GeckoAnalyticsProvider, useGeckoAnalytics }

export const SELECT_COMPONENT = {
  title: 'Select Component',
  description: 'Selected Component on Details Page',
}
export const SELECT_INSPECTION = {
  title: 'Select Inspection',
  description: 'Selected Inspection on Details Page',
}
export const LOGIN = {
  title: 'Log In Forecast',
  description: 'Log In to Forecast',
}
export const LOAD_DETAILS_PAGE = {
  title: 'Details Page',
  description: 'Loaded Asset Viz',
}
export const DOWNLOAD_FILE = {
  title: 'Download File',
  description: 'Downloaded File from Details Page',
}
export const SELECT_ALGORITHM = {
  title: 'Select Algorithm',
  description: 'Selected an Algorithm in Advanced Controls',
}
export const SELECT_AGGREGATION = {
  title: 'Select Aggregation',
  description: 'Selected an Aggregation in Advanced Controls',
}
export const SELECT_ANGLE_PLOT = {
  title: 'Select Angle Plot',
  description: 'Selected an Angle Plot Setting in Advanced Controls',
}
export const SELECT_T_MIN_METHOD = {
  title: 'Select T-Min Method',
  description: 'Selected a T-min Method in Advanced Controls',
}
export const SELECT_DEPTH = {
  title: 'Select Depth',
  description: 'Selected a Depth Range in Left Sidebar',
}
export const SELECT_BIN_SIZE = {
  title: 'Select Bin Size',
  description: 'Selected an Bin Size in Advanced Controls',
}
export const SELECTED_VIEW = {
  title: 'Select Data View',
  description: 'Selected a different Data View Than Default',
}

export const ENTITY_EDIT = {
  title: 'Entity Edit',
  description: 'User started editing an entity',
}

export const ENTITY_CANCEL_EDIT = {
  title: 'Entity Cancel Edit',
  description: 'User canceled editing an entity',
}

export const ENTITY_SAVE = {
  title: 'Entity Save',
  description: 'Entity save operation attempted',
}

export const DOCUMENT_FEEDBACK = {
  title: 'Document Feedback',
  description: 'User provided feedback on a document or document box/asset',
}

export const KNOWLEDGE_DOC_PAGE_NAVIGATE = {
  title: 'Knowledge Doc Page Navigate',
  description: 'User navigated to a different page in document viewer',
}

export const KNOWLEDGE_DOC_SELECT = {
  title: 'Knowledge Doc Select',
  description: 'User selected a document in document viewer',
}

export const KNOWLEDGE_DOC_TAB_ACTION = {
  title: 'Knowledge Doc Tab Action',
  description: 'User performed a tab action in document viewer',
}

export const KNOWLEDGE_DOC_FILTER_CHANGE = {
  title: 'Knowledge Doc Filter Change',
  description: 'User changed filter option in document viewer',
}

export const KNOWLEDGE_DOC_ASSET_TYPE_FILTER_CHANGE = {
  title: 'Knowledge Doc Asset Type Filter Change',
  description: 'User changed asset type filter in document viewer',
}

export const KNOWLEDGE_DOC_ACTION_MODE = {
  title: 'Knowledge Doc Action Mode',
  description: 'User changed action mode in document viewer',
}

export const KNOWLEDGE_DOC_OPTIONS_CHANGE = {
  title: 'Knowledge Doc Options Change',
  description: 'User changed display options in document viewer',
}

export const KNOWLEDGE_DOC_SIDEBAR_TOGGLE = {
  title: 'Knowledge Doc Sidebar Toggle',
  description: 'User toggled sidebar visibility in document viewer',
}

export const KNOWLEDGE_DOC_INTRA_DOC_SEARCH = {
  title: 'Knowledge Doc Intra Doc Search',
  description: 'User searched within a document in document viewer',
}

export const KNOWLEDGE_DOC_FULLSCREEN_TOGGLE = {
  title: 'Knowledge Doc Fullscreen Toggle',
  description: 'User toggled fullscreen mode in document viewer',
}

export const KNOWLEDGE_DOC_ADVANCED_SEARCH = {
  title: 'Knowledge Doc Advanced Search',
  description: 'User interacted with advanced search in document viewer',
}

export const KNOWLEDGE_DOC_BOX_INTERACTION = {
  title: 'Knowledge Doc Box Interaction',
  description: 'User interacted with a bounding box in document viewer',
}

export const KNOWLEDGE_DOC_ZOOM = {
  title: 'Knowledge Doc Zoom',
  description: 'User used zoom controls in document viewer',
}

export const KNOWLEDGE_DOC_HELP = {
  title: 'Knowledge Doc Help',
  description: 'User opened help modal in document viewer',
}

export const KNOWLEDGE_DOC_SEARCH_RESULTS = {
  title: 'Knowledge Doc Search Results',
  description: 'User interacted with saved search results in document viewer',
}

export const KNOWLEDGE_DOC_STATS = {
  title: 'Knowledge Doc Stats',
  description: 'User opened statistics modal in document viewer',
}

export const DOC_SEARCH_QUERY = {
  title: 'Doc Search Query',
  description: 'User submitted a search query in document search',
}

export const DOC_SEARCH_SELECT = {
  title: 'Doc Search Select',
  description: 'User selected a document from search results',
}

export const DOC_SEARCH_PREVIEW = {
  title: 'Doc Search Preview',
  description: 'User clicked a document to preview in search results',
}

export const DOC_SEARCH_RESULTS = {
  title: 'Doc Search Results',
  description:
    'Search results returned for a query with result count and latency',
}

export const DOC_SEARCH_DWELL = {
  title: 'Doc Search Dwell',
  description: 'User viewed a document preview for a measured duration',
}

export const DOC_CHAT = {
  title: 'Agentic Search',
  description:
    'Docchat completed, including query plan weights and fallback status',
}

export const DOC_CHAT_FEEDBACK = {
  title: 'Agentic Search Feedback',
  description: 'User rated a docchat response as helpful or reported an issue',
}

export const DOC_PAGE_LOAD = {
  title: 'Doc Page Load',
  description: 'User loaded a document page',
}

export const TIME_SERIES_VIEW = {
  title: 'Time Series View',
  description:
    'User viewed a historian time series (sensor/pen) in the dossier viewer',
}

export const FACILITY_MODEL_SUBJECT_OPEN = {
  title: 'Facility Model Subject Opened',
  description: 'User opened a Subject resource tab from the catalog or a link',
}

export const FACILITY_MODEL_EVIDENCE_OPEN = {
  title: 'Facility Model Evidence Opened',
  description: 'User explicitly opened an evidence document citation',
}

export const FACILITY_MODEL_TREND_OPEN = {
  title: 'Facility Model Trend Opened',
  description: 'User explicitly opened a process-data trend',
}

export const MODEL_OPERATIONS_SECTION_OPEN = {
  title: 'Model Operations Section Opened',
  description: 'User switched Model Operations sections',
}

export const FACILITY_MODEL_DATA_ISSUES_SEEN = {
  title: 'Facility Model Data Issues Encountered',
  description: 'Orphaned or inconsistent Asset Instances were surfaced',
}
